import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useParams } from 'react-router-dom';

const BlogPost = () => {
  const { id } = useParams(); // Récupère l'ID de l'article à partir de l'URL
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    // Appel à l'API pour récupérer un article spécifique
    axios.get(`https://www.clublfit.org/api/blogposts/${id}`)
      .then(response => {
        setPost(response.data);
        setLoading(false);
      })
      .catch(err => {
        setError('Erreur lors de la récupération de l\'article');
        setLoading(false);
      });
  }, [id]);

  if (loading) {
    return <p>Chargement de l'article...</p>;
  }

  if (error) {
    return <p className="text-danger">{error}</p>;
  }

  if (!post) {
    return <p>Aucun article trouvé.</p>;
  }

  return (
    <div className="container my-5">
      <h1 className="display-4 mb-4">{post.Titre_Post}</h1>
      {post.ImageUrl_Post && (
        <img 
          src={post.ImageUrl_Post} 
          alt={post.Titre_Post} 
          className="img-fluid mb-4" 
          style={{ maxHeight: '400px', objectFit: 'cover' }} 
        />
      )}
      <p className="text-muted">Publié le : {new Date(post.Date_Post).toLocaleDateString()} par le club {post.Nom_Club}</p>
      <p>{post.Contenu_Post}</p>
    </div>
  );
};

export default BlogPost;
